import { render, staticRenderFns } from "./company.vue?vue&type=template&id=24462dae&scoped=true&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24462dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24462dae')) {
      api.createRecord('24462dae', component.options)
    } else {
      api.reload('24462dae', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=24462dae&scoped=true&", function () {
      api.rerender('24462dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/company.vue"
export default component.exports